import { type Easing, type Transition, type Variants } from 'motion/react';

const springReveal = (delay: number): Transition => ({
  type: 'spring',
  stiffness: 420,
  damping: 32,
  mass: 0.75,
  delay,
});

/** Staggered spring reveal for setup steps (MotionConfig reducedMotion="user"). */
export const fadeInUp: Variants = {
  hidden: { opacity: 0, y: 14 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: springReveal(i * 0.09),
  }),
};

/** Opacity-only fallback when springs are inappropriate. */
export const fadeIn: Variants = {
  hidden: { opacity: 0 },
  visible: (i = 0) => ({
    opacity: 1,
    transition: {
      duration: 0.2,
      ease: [0.22, 1, 0.36, 1] as Easing,
      delay: i * 0.05,
    },
  }),
};
